import React, { useState } from "react";
import { Box, makeStyles } from "@material-ui/core";
import Page from "../components/Page";
import ListPlantsContainer from "../containers/plants/ListPlantsContainer";
import List from "../views/plants/ListPlants";
import DeviceContainer from "../containers/device/DeviceContainer";
import Create from "../views/plants/CreatePlant";
import { Fragment } from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: "100%",
    paddingBottom: theme.spacing(5),
    paddingTop: theme.spacing(4),
  },
}));

const PlantsPage = () => {
  const classes = useStyles();
  const [openCreate, setOpenCreate] = useState(false);

  return (
    <Page className={classes.root} title="Ecat">
      <Box px={3} pb={3}>
        <Box>
          <ListPlantsContainer>
            {({
              onConnectDevice,
              content,
              item,
              onCloseDevice,
              onUpdateRowsAndPages,
              updateStatus,
              addAction,
              date,
            }) => (
              <Fragment>
                <List
                  onUpdateRowsAndPages={onUpdateRowsAndPages}
                  onConnectDevice={onConnectDevice}
                  items={content ? content : []}
                  ekloksStatus={updateStatus}
                  add={addAction}
                  onAddAction={() => setOpenCreate(true)}
                />
                {item ? (
                  <DeviceContainer
                    item={item}
                    date={date}
                    onCloseDevice={onCloseDevice}
                  />
                ) : null}
              </Fragment>
            )}
          </ListPlantsContainer>
        </Box>
      </Box>
      <Create handleClose={() => setOpenCreate(false)} open={openCreate} />
    </Page>
  );
};

export default PlantsPage;
